(() => {
  if (customElements.get('cbd-card-purchase')) return;
  customElements.define('cbd-card-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select');
      this.card = this.closest('.card-wrapper');
      this.details = this.querySelector('details');
      this.summary = this.details.querySelector('summary');
      this.summary.setAttribute('aria-label', this.select.getAttribute('aria-label'));
      this.select.hidden = true;
      this.details.hidden = false;
      this.onChange = () => {
        const selected = this.select.selectedOptions[0];
        if (!selected) return;
        const price = this.card?.querySelector('.card-information .price');
        if (price) {
          price.classList.toggle('price--on-sale', Boolean(selected.dataset.compare));
          price.querySelectorAll('.price-item--regular').forEach(node => { node.textContent = selected.dataset.compare || selected.dataset.price; });
          price.querySelectorAll('.price-item--sale').forEach(node => { node.textContent = selected.dataset.price; });
        }
        this.querySelector('button[type="submit"]').disabled = selected.disabled;
        this.card?.querySelectorAll('.card__heading a').forEach(link => { link.href = selected.dataset.url; });
        this.querySelectorAll('[data-variant-id]').forEach(button => {
          const active = button.dataset.variantId === selected.value;
          button.setAttribute('aria-pressed', String(active));
          if (active) {
            this.querySelector('[data-selected-format]').replaceChildren(button.querySelector('[data-format-label]').cloneNode(true));
            this.summary.setAttribute('aria-label', `${this.select.getAttribute('aria-label')}, ${selected.textContent.trim()}`);
          }
        });
      };
      this.onClick = event => {
        const button = event.target.closest('[data-variant-id]');
        if (!button || button.disabled) return;
        this.select.value = button.dataset.variantId;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.details.open = false;
        this.summary.focus();
      };
      this.onKey = event => {
        if (event.key === 'Escape' && this.details.open) { event.preventDefault(); this.details.open = false; this.summary.focus(); }
      };
      this.onOutside = event => { if (!this.contains(event.target)) this.details.open = false; };
      this.select.addEventListener('change', this.onChange);
      this.details.addEventListener('click', this.onClick);
      this.details.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onOutside);
      this.onChange();
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
      this.details?.removeEventListener('click', this.onClick);
      this.details?.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onOutside);
      this.ready = false;
    }
  });
})();
